<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mh-100vh">
      <div class="col-12 text-center">
        <h2>お探しのページは見つかりませんでした</h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>



// WEBPACK FOOTER //
// src/pages/NotFound.vue